const PUBLIC_URL = process.env.PUBLIC_URL || "";

export const ImageSrc = {
  headerImages: {
    userProfile: `${PUBLIC_URL}/images/header-images/user-profile-dummy.svg`,
    closeDrawer: `${PUBLIC_URL}/images/header-images/close-drawer.svg`,
    whatsappLogo: `${PUBLIC_URL}/images/header-images/whatsapp-logo.svg`,
    mail: `${PUBLIC_URL}/images/header-images/mail.svg`,
    arrowLeftAlt: `${PUBLIC_URL}/images/header-images/arrow_left_alt.svg`,
    logout: `${PUBLIC_URL}/images/header-images/logout-icon.svg`,
    pace: `${PUBLIC_URL}/images/header-images/pace-logo.png`,
  },
};
